import { createRoutine } from 'redux-routines';
import {
  INIT, LOADING, SUCCESS, FAILURE,
} from '@constants/requestPhase';
import * as api from './api';

// < ----- ACTIONS ----- > //
const getMetadataRoutine = createRoutine(
  'GET_METADATA',
);

const getMetadataNavigationRoutine = createRoutine(
  'GET_METADATA_NAVIGATION',
);

const getReferFriendOptionsRoutine = createRoutine(
  'GET_REFER_FRIEND_OPTIONS'
);

// < ----- ACTION CREATORS ----- > //
export const getMetadata = () => async dispatch => {
  try {
    dispatch(getMetadataRoutine.request());

    const response = await api.getMetadata();

    return dispatch(getMetadataRoutine.success(response.data));
  } catch (error) {
    return dispatch(getMetadataRoutine.failure(error.response));
  }
};

export const getMetadataNavigation = id => async dispatch => {
  try {
    dispatch(getMetadataNavigationRoutine.request());

    const response = await api.getMetadataNavigation(id);

    return dispatch(getMetadataNavigationRoutine.success(response.data));
  } catch (error) {
    return dispatch(getMetadataNavigationRoutine.failure(error.response));
  }
};

export const getReferFriendOptions = () => async dispatch => {
  try {
    dispatch(getReferFriendOptionsRoutine.request());

    const response = await api.getReferFriendOptions();

    return dispatch(getReferFriendOptionsRoutine.success(response.data));
  } catch (error) {
    return dispatch(getReferFriendOptionsRoutine.failure(error.response));
  }
};

// < ----- STATE ----- > //
export const userStorePersistWhitelist = [];

const initialState = {
  metadata: {},
  navigationItems: [],
  referFriend: {},

  getMetadataPhase: INIT,
  getMetadataError: null,

  getMetadataNavigationPhase: INIT,
  getMetadataNavigationError: null,

  getReferFriendOptionsPhase: INIT,
  getReferFriendOptionsError: null,
};

// < ----- STORE REDUCER ----- > //
const store = (state = initialState, { type, payload }) => {
  switch (type) {
    // GET METADATA
    case getMetadataRoutine.REQUEST:
      return {
        ...state,
        getMetadataPhase: LOADING,
      };
    case getMetadataRoutine.SUCCESS:
      return {
        ...state,
        metadata: payload.data,
        getMetadataPhase: SUCCESS,
      };
    case getMetadataRoutine.FAILURE:
      return {
        ...state,
        getMetadataPhase: FAILURE,
        getMetadataError: payload,
      };
    case getMetadataNavigationRoutine.REQUEST:
      return {
        ...state,
        getMetadataNavigationPhase: LOADING,
      };
    case getMetadataNavigationRoutine.SUCCESS:
      return {
        ...state,
        navigationItems: payload.data.items,
        getMetadataNavigationPhase: SUCCESS,
      };
    case getMetadataNavigationRoutine.FAILURE:
      return {
        ...state,
        getMetadataNavigationPhase: FAILURE,
        getMetadataNavigationError: payload,
      };
      // REFER FRIEND
      case getReferFriendOptionsRoutine.REQUEST:
      return {
        ...state,
        getReferFriendOptionsPhase: LOADING,
      };
    case getReferFriendOptionsRoutine.SUCCESS:
      return {
        ...state,
        referFriend: payload.data,
        getReferFriendOptionsPhase: SUCCESS,
      };
    case getReferFriendOptionsRoutine.FAILURE:
      return {
        ...state,
        getReferFriendOptionsPhase: FAILURE,
        getReferFriendOptionsError: payload,
      };
    default:
      return state;
  }
};

export default store;
